export default class EventManager {
  constructor() {
    this.subscriptions = [];
  }

  bindEvent(element, eventName, event) {
    element.addEventListener(eventName, event);
    this.subscriptions.push({ element, event: eventName, func: event });
  }

  unsubscribe() {
    this.subscriptions.forEach(({ element, event, func }) => {
      element.removeEventListener(event, func);
    });
  }
}